import { initialState } from './initialState';
export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'NPS_FEEDBACK_LOADING':
      return {
        ...state,
        isLoading: true,
        success: false,
        error: false,
      };

    case 'NPS_FEEDBACK_SUCCESS':
      return {
        ...state,
        isLoading: false,
        success: true,
        nps_feedback_data: action.payload.data,
        error: false,
      };

    case 'NPS_FEEDBACK_ERROR':
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload.response ? action.payload.response.data : action.payload.data,
      };
   
    default:
      return {
        ...state,
      };
  }
}
